var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CrudList',{attrs:{"title":"Solicitudes de trabajo","storeName":"Work_requests","labelAddNew":"Agregar Nueva Solicitud de trabajo","sortable":"","canSearch":""},scopedSlots:_vm._u([{key:"country_id",fn:function({ item }){return [_vm._v(" "+_vm._s(item.country_id?.name ? item.country_id.name : "")+" ")]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }